import * as React from 'react';
import { History } from 'history';
import Model from './quizresult-model';
import BaseChecklist from '../base/base-checklist.component';

interface IProps { 
  history: History;
  readOnly?: boolean
  disableBackButton? : boolean
  currentId: any;
  onLoad?: (data: any) => void;
}

interface IState {
}

export default class QuizresultChecklist extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <BaseChecklist history={this.props.history} model={Model} readOnly={this.props.readOnly} currentId={this.props.currentId} onLoad={this.props.onLoad} disableBackButton/>
    );
  }
}
